import type { FieldError } from './types';

/**
 * Safely extract an error message at a given path inside a FormErrors tree.
 *
 * Returns `undefined` if any segment of the path is missing or the value at
 * the final segment isn't a string. Callers can pass any depth of path:
 *
 *   getFieldError(errors, 'client')                // string | undefined
 *   getFieldError(errors, 'config', 'platform')    // string | undefined
 *   getFieldError(errors, 'config', 'mappings', 'groups')
 */
export default function getFieldError(errors: unknown, ...path: (string | number)[]): string | undefined {
  let current: unknown = errors;
  for (const segment of path) {
    if (current == null || typeof current !== 'object') return undefined;
    current = (current as Record<string | number, unknown>)[segment];
  }
  return typeof current === 'string' ? current : undefined;
}

export type { FieldError };
